(function () {
    'use strict';

    angular
        .module('riskSelfAssessmentReviewControllers')
        .directive('keyRiskToReview', directive);

    directive.$inject = [];

    function directive() {
        return {
            scope: {
                keyRisk: '=',
                onUpdate: '&',
                withPreviousAssessments: '='
            },
            restrict: 'AE',
            templateUrl: require('./keyRiskToReview.tpl.html'),
            controller: ['$scope', '$modal', 'riskSelfAssessmentReviewService',
                function ($scope, $modal, riskSelfAssessmentReviewService) {

                    $scope.init = function () {
                        $scope.dirCtxt = {};
                    };

                    $scope.onUpdateRatings = function () {
                        $scope.onUpdate();
                    };

                    // Reset Assessment
                    $scope.resetAssessment = function () {
                        $scope.dirCtxt.isLoading = true;

                        return riskSelfAssessmentReviewService
                            .resetFinalChangesOnRiskAssessment($scope.keyRisk)
                            .then(function (keyRiskToReview) {
                                $scope.keyRisk.Assessment = keyRiskToReview.Assessment;

                                $scope.onUpdate();
                            })
                            .finally(function () {
                                $scope.dirCtxt.isLoading = false;
                            });
                    };

                    // Set Pre Final Values
                    $scope.setPreFinalValues = function () {
                        $scope.keyRisk.Assessment.PreFinalProbabilityCode     = $scope.keyRisk.Assessment.PreFinalProbabilityCode || $scope.keyRisk.Assessment.InitialProbabilityCode;
                        $scope.keyRisk.Assessment.PreFinalMitigationCode      = $scope.keyRisk.Assessment.PreFinalMitigationCode || $scope.keyRisk.Assessment.InitialMitigationCode;
                        $scope.keyRisk.Assessment.PreFinalSeverityCode        = $scope.keyRisk.Assessment.PreFinalSeverityCode || $scope.keyRisk.Assessment.InitialSeverityCode;
                        $scope.keyRisk.Assessment.PreFinalOverallCode         = $scope.keyRisk.Assessment.PreFinalOverallCode || $scope.keyRisk.Assessment.InitialOverallCode;
                        $scope.keyRisk.Assessment.PreFinalComputedOverallCode = $scope.keyRisk.Assessment.PreFinalComputedOverallCode || $scope.keyRisk.Assessment.InitialComputedOverallCode;
                        $scope.keyRisk.Assessment.PreFinalOverrideExplanation = $scope.keyRisk.Assessment.PreFinalOverrideExplanation || $scope.keyRisk.Assessment.InitialOverrideExplanationOverall;
                        $scope.keyRisk.Assessment.PreFinalIsOverriden         = _.isBoolean($scope.keyRisk.Assessment.PreFinalIsOverriden) ?
                            $scope.keyRisk.Assessment.PreFinalIsOverriden : $scope.keyRisk.Assessment.InitialIsOverrideOverall;

                        $scope.dirCtxt.haveRatingsChanged = haveRatingsChanged();
                    };

                    $scope.openChangeKeyRiskRatingsModal = function ($event) {
                        $event.stopPropagation();

                        // Modal to show
                        var modalScope     = $scope.$new(true);
                        modalScope.keyRisk = _.cloneDeep($scope.keyRisk);
                        modalScope.ratingsChanged = false;
                        modalScope.showRatingChangedComment = !!modalScope.keyRisk.Assessment.PreFinalOverrideExplanation;

                        var showModal = $modal({
                            scope: modalScope,
                            template: require('./changeKeyRiskRatingsModal.tpl.html'),
                            placement: 'center'
                        });

                        // Hide Modal
                        modalScope.hideModal = function (ratingsChanged) {
                            showModal.$promise.then(showModal.hide);
                            if (ratingsChanged) {
                                $scope.onUpdate();
                            }
                        };

                        // OK Modal
                        modalScope.okModal = function () {
                            modalScope.hideModal();
                        };

                        // Pre Final Rating Modified
                        modalScope.ratingChanged = function () {
                            modalScope.showRatingChangedComment =
                                modalScope.keyRisk.Assessment.InitialProbabilityCode   !== modalScope.keyRisk.Assessment.PreFinalProbabilityCode
                                || modalScope.keyRisk.Assessment.InitialSeverityCode   !== modalScope.keyRisk.Assessment.PreFinalSeverityCode
                                || modalScope.keyRisk.Assessment.InitialMitigationCode !== modalScope.keyRisk.Assessment.PreFinalMitigationCode
                                || modalScope.keyRisk.Assessment.InitialOverallCode    !== modalScope.keyRisk.Assessment.PreFinalOverallCode;

                            if (!modalScope.showRatingChangedComment) {
                                modalScope.keyRisk.Assessment.PreFinalOverrideExplanation = null;
                            }
                        };

                        // Update PreFinal Changes
                        modalScope.updatePreFinalChanges = function () {

                            return riskSelfAssessmentReviewService
                                .updateKeyRiskPreFinalAssessment(modalScope.keyRisk)
                                .then(function (keyRiskToReview) {
                                    $scope.keyRisk.Assessment = keyRiskToReview.Assessment;
                                    modalScope.hideModal(true);
                                });
                        };

                        // Confirm Final Changes
                        modalScope.confirmFinalChanges = function () {
                            if ($scope.showRatingChangedComment && !$scope.keyRisk.Assessment.FinalOverrideExplanation) return;

                            $scope.dirCtxt.isLoading = true;

                            return riskSelfAssessmentReviewService
                                .reviewRiskByAssessor(modalScope.keyRisk)
                                .then(function (riskToReview) {
                                    $scope.keyRisk.Assessment = riskToReview.Assessment;
                                    modalScope.hideModal();
                                })
                                .finally(function () {
                                    $scope.dirCtxt.isLoading = false;
                                });
                        };

                        // Discard Changes
                        modalScope.discardChanges = function () {

                            return riskSelfAssessmentReviewService
                                .discardPreFinalChangesOnRiskAssessment($scope.keyRisk)
                                .then(function (keyRiskToReview) {
                                    $scope.keyRisk.Assessment = keyRiskToReview.Assessment;

                                    return refreshKeyRisks()
                                        .then(function () {
                                            modalScope.hideModal();
                                        });
                                });
                        };
                    };

                    function haveRatingsChanged() {
                        if ($scope.keyRisk.Assessment.PreFinalProbabilityCode !== $scope.keyRisk.Assessment.InitialProbabilityCode) return true;
                        if ($scope.keyRisk.Assessment.PreFinalMitigationCode !== $scope.keyRisk.Assessment.InitialMitigationCode) return true;
                        if ($scope.keyRisk.Assessment.PreFinalSeverityCode !== $scope.keyRisk.Assessment.InitialSeverityCode) return true;
                        if ($scope.keyRisk.Assessment.PreFinalOverallCode !== $scope.keyRisk.Assessment.InitialOverallCode) return true;
                        if ($scope.keyRisk.Assessment.PreFinalComputedOverallCode !== $scope.keyRisk.Assessment.InitialComputedOverallCode) return true;
                    }

                }],
            link: function (scope, element, attrs) {
                scope.init();

                scope.$watch('keyRisk.Assessment', function (newValue) {
                    if (!newValue) return;

                    scope.setPreFinalValues();
                }, true);
            }
        };
    }
})();
